import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';
import orderBy from 'lodash/orderBy';
import moment from 'moment';

export const initialState = {
  isNewNotifications: false,
  notifications: [],
  interval: [],
};

const notification = handleActions(
  {
    SET_UNREAD_NOTIFICATIONS: (state, action) => {
      const { isNewNotifications } = action.payload;
      return {
        ...state,
        isNewNotifications,
      };
    },
    SET_NOTIFICATIONS: (state, action) => {
      const { notifications, pagination } = action.payload;

      const orderedNotifications = orderBy(
        notifications,
        [n => moment(n.created_at).format('x')],
        ['desc'],
      );

      return {
        ...state,
        notifications: orderedNotifications,
        pagination,
      };
    },
    SET_READ_NOTIFICATION: (state, { payload }) => {
      const { notifications } = state;

      const changedNotifications = cloneDeep(notifications).map(
        n => (n.id === payload.id ? payload : n),
      );

      return {
        ...state,
        notifications: changedNotifications,
      };
    },
    SET_NOTIFICATIONS_THREAD_INTERVAL: (state, action) => {
      const { interval } = action.payload;
      return {
        ...state,
        interval: [...state.interval, interval],
      };
    },
    CLEAR_NOTIFICATIONS_THREAD_INTERVAL: state => {
      state.interval.map(int => clearInterval(int));

      return {
        ...state,
        interval: [],
      };
    },
    AUTHENTICATION_LOGOUT: () => ({
      ...initialState,
    }),
  },
  initialState,
);

export default notification;



// WEBPACK FOOTER //
// ./src/store/reducers/Notification/index.js